import { use } from '@fegobull/webapi';
import { Channel } from './constants';
import { computed, ref, watch } from 'vue-demi';

// 语种
export const Language = {
    // 英文
    EN: 'en',
    // 简体
    SC: 'sc',
    // 繁体
    TC: 'tc',
    // 日语
    JP: 'jp'
};

const { useI18n } = use;
const languageMap = {
    [Language.EN]: {
        names: {
            [Channel.SYSTEM]: 'More',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: '小红书',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram'
        }
    },
    [Language.SC]: {
        names: {
            [Channel.SYSTEM]: '更多',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: '小红书',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram'
        }
    },
    [Language.TC]: {
        names: {
            [Channel.SYSTEM]: '更多',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: '小红书',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram'
        }
    },
    [Language.JP]: {
        names: {
            [Channel.SYSTEM]: '…',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: '小紅書',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram'
        }
    }
};

// 当前语种
export const currentLanguage = ref(Language.EN);

// 设置语种
function setCurrentLanguage(language) {
    currentLanguage.value = language;
}

// i18n
const compI18n = computed(() => useI18n(languageMap, currentLanguage.value));

export const _lang = (...args) => compI18n.value(...args);

// 监听语种变化
export function watchLanguage(source) {
    return watch(
        source,
        (value) => {
            setCurrentLanguage(value);
        },
        {
            immediate: true
        }
    );
}
